<template>
  <section class="section section-shaped section-lg my-0">
      <div class="shape shape-style-1 bg-gradient-default">
      </div>
      <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div class="text-muted text-center mb-3">
                                <h4>Recuperar Senha</h4>
                                <p class="mb-1">Por favor, preencha seu e-mail de cadastro para recuperar sua senha</p>
                            </div>
                        </template>
                        <template>
                            <form role="form" @submit.prevent method="get">
                                <base-input alternative
                                            v-model="inputs.email"
                                            id="email"
                                            class="mb-3"
                                            placeholder="Seu e-mail"
                                            addon-left-icon="ni ni-email-83">
                                </base-input>
                                <div class="mt-4 mb-2">
                                    <vue-recaptcha ref="recaptcha" :sitekey="recaptchaKey" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired" class="recaptcha-block"></vue-recaptcha>
                                </div>
                                <div class="text-center">
                                    <base-button nativeType="submit" @click="send_reset_token($event)" type="primary" class="my-4">Enviar</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <div class="row mt-3">
                        <div class="col-12 text-center">
                            <router-link to="/login" class="text-light">
                                <small>&#x27F5; Voltar e fazer Login</small>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import { userMixin } from "@/mixins/userMixin";

export default {
  mixins: [userMixin],
  data() {
    return {
      modal: {
        title: 'Falha na Operação!',
        body: 'Não foi possível completar a operação',
        classe: 'modal-danger',
        icon: 'fa fa-times-circle',
        okButton: 'OK',
      },
    };
  },
  methods: {
    ...mapActions('password', [
      'clearEmailStatus',
    ]),
  },
  computed: {
    ...mapGetters('auth', [
        'isAuthenticated',
      ]),
    ...mapState('password', [
        'emailCompleted',
        'emailError',
        'emailLoading',
      ]),
  },
  beforeRouteLeave(to, from, next) {
    this.clearEmailStatus();
    this.inputs.email = ''
    next();
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
          if ( vm.$store.state.modal.showModal == true ) {
              vm.$store.commit('modal/toggleModal');
          }
      })
  }
};
</script>
